<template>
  <div class="absolute inset-0 flex items-center justify-center">
    <button class="btn btn-circle h-16 w-16 bg-white md:h-24 md:w-24" aria-label="play video">
      <SvgIcon class="h-6 w-6 text-black xl:h-8 xl:w-8" name="Play"></SvgIcon>
    </button>
  </div>
</template>

<script setup>
import SvgIcon from "~/templates/elements/SvgIcon.vue";
</script>
